import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'
import IMask from 'imask'

export default function PageContato() {
	const contato = find("[js-page='contato']")
	if (!contato) return

	const element = document.querySelector('#form-protecao input[name=telefone]')
	const maskOptions = {
		mask: [
			{
				mask: '(00) 0000-0000',
			},
			{
				mask: '(00) 00000-0000',
			},
		],
	}
	const mask = IMask(element, maskOptions)

	const contatoFormSubmit = document.querySelector('#form-protecao')

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message
		showToastify(message)
		contatoFormSubmit.reset()
		setTimeout(enabledBtn, 1000)
	}

	const btnSubmit = document.querySelector('#form-protecao button[type=submit]')

	function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
	}

	function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
	}

	contatoFormSubmit &&
		contatoFormSubmit.addEventListener('submit', function (event) {
			event.preventDefault()
			disabledBtn()

			const formData = new FormData()
			formData.append('nome', document.querySelector('#form-protecao input[name=nome]').value)
			formData.append('email', document.querySelector('#form-protecao input[name=email]').value)
			formData.append('telefone', document.querySelector('#form-protecao input[name=telefone]').value)
			formData.append('mensagem', document.querySelector('#form-protecao textarea[name=mensagem]').value)
			formData.append('assunto', document.querySelector('#form-protecao input[name=assunto]').value)
			//formData.append('assunto', document.querySelector('#form-contato select[name=assunto]').value)

			const url = '/protecao-de-dados/'
			axios
				.post(url, formData)
				.then((response) => showMessage(response))
				.catch((response) => showMessage(response))
		})
}
